import { Controller, useFormContext } from "react-hook-form";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import SelectHookFormMulti from "../../../../components/SelectHookFormMulti";
import { useStates } from "../../hooks/useStates";
import CarrierAttachments from "./CarrierAttachments";
import { useGetAMBestRating } from "../hooks/useGetAMBestRating";
import CheckBoxLabelHookForm from "../../../../components/CheckBoxLabelHookForm";
import { useRecoilState } from "recoil";
import {
  ICarrierContactPerState,
  ICarrierMetricsPerState,
  ICarrierStateAppointed,
  IStatesOptions,
} from "../types";
import {
  carrierContactPerState,
  carrierMetricPerState,
  carrierStateAppointed,
} from "../atom/atoms";
import CheckBoxLabelHookFormDigitized from "../../../../components/CheckBoxLabelHookFormDigitized";

const CarrierDetails = ({ setIsFileDelete }) => {
  const [contactsPerState, setCarrierContactPerState] = useRecoilState<
    Array<ICarrierContactPerState>[]
  >(carrierContactPerState);
  //
  const [metricsPerState, setCarrierMetricsPerState] = useRecoilState<
    Array<ICarrierMetricsPerState>[]
  >(carrierMetricPerState);
  const [stateAppointed, setCarrierStateAppointed] = useRecoilState<
    Array<ICarrierStateAppointed>[]
  >(carrierStateAppointed);
  //For dropdown options
  const { data: states, isLoading: statesLoading } = useStates();
  const stateOptions = states?.map((x) => {
    return {
      label: x.state,
      value: x.stateId,
    };
  });

  const { data: bestRating, isLoading: getAMBestLoading } =
    useGetAMBestRating();
  const bestRatingOptions = bestRating?.map((x) => {
    return {
      label: x.ambestRatingName,
      value: x.ambestRatingName,
    };
  });
  //

  const useFormMethods = useFormContext();
  const {
    control,
    formState: { errors },
    register,
    watch,
    setValue,
  } = useFormMethods;

  const handleMultiStateSelect = (checkedStates) => {
    //current selected states
    const statesSelected = watch("states")?.map((x) => x.label);
    const oldStates =
      contactsPerState?.length > 0
        ? contactsPerState?.map((x) => x[0].stateCode)
        : [];

    if (checkedStates.length === 0 || checkedStates === null) {
      setCarrierContactPerState([]);
      setCarrierMetricsPerState([]);
      setCarrierStateAppointed([]);
    } else {
      //function for removing unchecked state from carrierContactPerState

      if (watch("states")?.length > 0) {
        const contactsPerStateClone = contactsPerState.map((contact) => {
          return [...watch(`contactState_${contact[0].stateCode}`)];
        });
        const metricsPerStateClone = metricsPerState.map((metrics) => {
          return [...watch(`metricState_${metrics[0]?.state}`)];
        });
        contactsPerStateClone.forEach((stateContact, index) => {
          if (!statesSelected.includes(stateContact[0].stateCode)) {
            contactsPerStateClone.splice(index, 1);
          }
        });
        metricsPerStateClone.forEach((stateMetric, index) => {
          if (!statesSelected.includes(stateMetric[0].state)) {
            metricsPerStateClone.splice(index, 1);
          }
        });
        //two level spread for object assigning (fixed: Cannot assign to read only property)
        setCarrierContactPerState(
          contactsPerStateClone.map((contact, index) => [
            ...contact.map((data) => {
              return { ...data, parentRow: index > 0 ? false : true }; //re-assigning parent rows
            }),
          ])
        );

        setCarrierMetricsPerState(
          metricsPerStateClone.map((metrics, index) => [
            ...metrics.map((data) => {
              return { ...data, parentRow: index > 0 ? false : true }; //re-assigning parent rows
            }),
          ])
        );
        //Carrier State Appointed
        const stateAppointedClone = stateAppointed.map((app) => {
          return [...watch(`stateAppointed_${app[0].states}`)];
        });
        stateAppointedClone.forEach((stateAppointed, index) => {
          if (!statesSelected.includes(stateAppointed[0].states)) {
            stateAppointedClone.splice(index, 1);
          }
        });
        //two level spread for object assigning (fixed: Cannot assign to read only property)
        setCarrierStateAppointed(
          stateAppointedClone.map((row, index) => [
            ...row.map((data) => {
              return { ...data, parentRow: index > 0 ? false : true }; //re-assigning parent rows
            }),
          ])
        );
      }

      //function for adding checked state to carrierContactPerState

      checkedStates.forEach((state: IStatesOptions, index: number) => {
        if (!oldStates.includes(state.label)) {
          setCarrierContactPerState([
            ...contactsPerState,
            [
              {
                parentRow: index > 0 ? false : true,
                tableName: "contactState_" + state.label,
                carrierContactPerStateId: null,
                stateId: state.value,
                stateCode: state.label,
                eAndOId: null,
              },
            ],
          ]);
          setCarrierMetricsPerState([
            ...metricsPerState,
            [
              {
                parentRow: index > 0 ? false : true,
                tableName: "metricState_" + state.label,
                carrierMetricsPerStateId: null,
                stateId: state.value,
                state: state.label,
              },
            ],
          ]);
          setCarrierStateAppointed([
            ...stateAppointed,
            [
              {
                parentRow: index > 0 ? false : true,
                tableName: "stateAppointed_" + state.label,
                stateAppointedId: null,
                stateId: state.value,
                states: state.label,
              },
            ],
          ]);
        }
      });
    }
  };
  const handleNSACheckbox = (checked: true | false) => {
    if (checked) {
      setValue("nsaContacts", [
        {
          parentRow: true,
          tableName: "nsaContacts",
        },
      ]);
    }
  };
  const handleSPLCCheckbox = (checked: true | false) => {
    if (checked) {
      setValue("splcContacts", [
        {
          parentRow: true,
          tableName: "splcContacts",
        },
      ]);
    }
  };

  return (
    <div className="mt-10 bg-white box-shadow rounded-lg h-full pb-4">
      <div className="grid grid-cols-5">
        <div className="col-span-3 text-quinary font-bold text-sm font-sans py-2 px-4">
          Carrier Information
        </div>
        <div className="text-quinary font-bold text-sm font-sans py-2 px-4">
          Attachments
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-5 px-4 gap-6">
        <div className="col-span-3 grid grid-cols-1 md:grid-cols-4 gap-x-4 gap-y-2">
          <TextInputLabelHookForm
            label="Carrier Name"
            type="text"
            required={true}
            className={
              errors.carrierName && "border-2 border-red-500 col-span-2"
            }
            register={register("carrierName", {
              required: {
                value: true,
                message: "Required Field",
              },
            })}
            secondDiv="grid grid-cols-1"
          />
          <TextInputLabelHookForm
            label="Alias"
            type="text"
            register={register("masterCarrierDetails.alias", {})}
            secondDiv="grid grid-cols-1"
          />
          <TextInputLabelHookForm
            label="Address"
            type="text"
            register={register("masterCarrierDetails.masterCarrierAddress", {})}
            secondDiv="grid grid-cols-1"
          />
          <Controller
            control={control}
            name="states"
            rules={{ required: true }}
            render={({ field }) => (
              <SelectHookFormMulti
                field={field}
                onChange={(e) => {
                  field.onChange(e);
                  handleMultiStateSelect(e);
                }}
                value={field.value}
                options={stateOptions}
                isLoading={statesLoading}
                label="State"
                className={
                  errors.states && "border-2 border-red-500 col-span-2 "
                }
                secondDiv="grid grid-cols-1"
                isRequired={true}
              />
            )}
          />
          <TextInputLabelHookForm
            label="FEIN"
            type="text"
            register={register("fein", {})}
            secondDiv="grid grid-cols-1"
          />
          <TextInputLabelHookForm
            label="NAIC"
            type="text"
            register={register("naic", {})}
            secondDiv="grid grid-cols-1"
          />
          <Controller
            control={control}
            name="amBestRating"
            render={({ field }) => (
              <SelectHookFormSingle
                label="A.M Best Rating"
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value ? field.value : null}
                options={bestRatingOptions}
                isLoading={getAMBestLoading}
                className={
                  errors.masterCarrierId && "border-2 border-red-500 col-span-2"
                }
                secondDiv="grid grid-cols-1"
              />
            )}
          />
          <TextInputLabelHookForm
            name="dateOfAmBestRating"
            label="Date of A.M Best Rating"
            type="date"
            register={register("dateOfAmBestRating", {})}
            className={errors.officeOpenedDate && "border-2 border-red-500 "}
            secondDiv="grid grid-cols-1"
          />

          <CheckBoxLabelHookFormDigitized
            name="isDigitized"
            label="Digitized"
            type="checkbox"
            disabled={true}
            register={register}
          />

          <CheckBoxLabelHookForm
            name="isActive"
            label="Active"
            type="checkbox"
            register={register}
          />

          <CheckBoxLabelHookForm
            name="masterCarrierDetails.nsa"
            label="NSA"
            type="checkbox"
            register={register}
            onClick={(e) => handleNSACheckbox(e.target.checked)}
          />

          <CheckBoxLabelHookForm
            name="masterCarrierDetails.splc"
            label="SPLC"
            type="checkbox"
            register={register}
            onClick={(e) => handleSPLCCheckbox(e.target.checked)}
          />
        </div>
        <div className="col-span-2">
          <CarrierAttachments setIsFileDeletes={setIsFileDelete} />
        </div>
      </div>
    </div>
  );
};

export default CarrierDetails;
